<!--
	SearchChip.svelte
-->

<script>
    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiCloseCircleOutline } from '@mdi/js';

    export let selectedNode;
    export let onChipClick;
    

    onMount(() => {
    })

</script>

<style>
    .search-chip {
        display: flex;
        align-items: center;
        padding: 2px 4px;
        margin: 0px 3px 3px 0px;
        font-size: .8em;
        color: var(--tcare-white);
        background-color: var(--tcare-primary);
        /* border-radius: 14px; */
        border-radius: 4px;
        user-select: none;
    }

    .chip-label {
        margin: 0px 2px;
        color: var(--tcare-white);
    }

    .search-chip:hover {
        background-color: var(--tcare-secondary);
    }

    :global(.search-chip svg) {
        width: 20px;
        height: 20px;
        fill: var(--tcare-white);
        outline: none;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="search-chip" on:click={() => onChipClick(selectedNode)} style={`background-color: ${selectedNode.color}`}>
    <div class="chip-label">{selectedNode.label}</div>
    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCloseCircleOutline} /></Icon>
</div>
